import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import type { ICustomerUserPermissions } from '@albacross/types'

import { useAddNotification } from 'hooks/useAddNotification'
import { put } from 'utils/http'

type CustomerUserUpsertParams = {
  userId: number
  roleId?: number | string
  jobDepartment?: string | null
  jobTitle?: string | null
  permissions?: Partial<ICustomerUserPermissions['permissions']>
}

export const useCustomerUserUpsert = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const upsertCustomerUser = ({ userId, roleId, jobDepartment, jobTitle, permissions }: CustomerUserUpsertParams) =>
    put(`/management/customers/${customerId}/users/${userId}`, {
      user: {
        role_id: roleId,
        job_department: jobDepartment,
        job_title: jobTitle,
        permissions,
      },
    })

  return useMutation({
    mutationFn: upsertCustomerUser,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'users'] })
      addNotification('User has been updated successfully')
    },
    onError: () => {
      addNotification('Error while updating user', 'error')
    },
  })
}
